 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"downloads":"downloads","encyclopedia":"encyclopedia","encyclopedia/achievements":"encyclopedia/achievements","encyclopedia/achievements/category":"encyclopedia/achievements/category","encyclopedia/achievements/details":"encyclopedia/achievements/details","encyclopedia/giants":"encyclopedia/giants","encyclopedia/giants/details":"encyclopedia/giants/details","encyclopedia/home":"encyclopedia/home","encyclopedia/inhabitants":"encyclopedia/inhabitants","encyclopedia/inhabitants/category":"encyclopedia/inhabitants/category","encyclopedia/inhabitants/details":"encyclopedia/inhabitants/details","encyclopedia/items":"encyclopedia/items","encyclopedia/items/category":"encyclopedia/items/category","encyclopedia/items/details":"encyclopedia/items/details","encyclopedia/locations":"encyclopedia/locations","encyclopedia/locations/details":"encyclopedia/locations/details","encyclopedia/locations/region":"encyclopedia/locations/region","encyclopedia/search":"encyclopedia/search","encyclopedia/skills":"encyclopedia/skills","encyclopedia/skills/category":"encyclopedia/skills/category","encyclopedia/skills/details":"encyclopedia/skills/details","encyclopedia/upgrades":"encyclopedia/upgrades","encyclopedia/upgrades/category":"encyclopedia/upgrades/category","encyclopedia/upgrades/details":"encyclopedia/upgrades/details","feats":"feats","feats/details":"feats/details","feats/home":"feats/home","forums":"forums","forums/details":"forums/details","forums/home":"forums/home","forums/search":"forums/search","forums/topic":"forums/topic","help":"help","oddnet":"oddnet","password":"password","privacy":"privacy","profile":"profile","profile/achievements":"profile/achievements","profile/feats":"profile/feats","profile/home":"profile/home","profile/notifications":"profile/notifications","profile/post":"profile/post","profile/settings":"profile/settings","profile/skills":"profile/skills","profile/upgrades":"profile/upgrades","search":"search","subscriptions":"subscriptions","terms":"terms"}[chunkId]||chunkId) + "." + {"downloads":"6d994903","encyclopedia":"710face1","encyclopedia/achievements":"3f0598a2","encyclopedia/achievements/category":"becdf687","encyclopedia/achievements/details":"e32c58ed","encyclopedia/giants":"6cfad7e8","encyclopedia/giants/details":"544ddf6d","encyclopedia/home":"12929ce1","encyclopedia/inhabitants":"ead1075c","encyclopedia/inhabitants/category":"a30aa611","encyclopedia/inhabitants/details":"9d3bd5f4","encyclopedia/items":"62a5f336","encyclopedia/items/category":"9ea650c5","encyclopedia/items/details":"df400b39","encyclopedia/locations":"25071883","encyclopedia/locations/details":"c8d6ba9e","encyclopedia/locations/region":"e751f9a8","encyclopedia/search":"da0d37d3","encyclopedia/skills":"f6ac2afd","encyclopedia/skills/category":"dad36367","encyclopedia/skills/details":"82566f02","encyclopedia/upgrades":"e1caf3e0","encyclopedia/upgrades/category":"317b3816","encyclopedia/upgrades/details":"8e8a44ce","feats":"da0b4a51","feats/details":"6cf19476","feats/home":"3dccfe4e","forums":"ea8bc12b","forums/details":"5d34a727","forums/home":"05f5d04a","forums/search":"36632343","forums/topic":"0cc00907","help":"088a294f","oddnet":"ba5b0742","password":"910fc666","privacy":"03ec92f1","profile":"32663e53","profile/achievements":"6b5f96ac","profile/feats":"5a9018f2","profile/home":"88750ed6","profile/notifications":"187ca254","profile/post":"29a46843","profile/settings":"df8bf61a","profile/skills":"c091cdf1","profile/upgrades":"f1a37d3f","search":"c31d6252","subscriptions":"bb12e77e","terms":"cebd29e3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"encyclopedia/achievements/details":1,"encyclopedia/inhabitants/details":1,"encyclopedia/items/details":1,"encyclopedia/skills/details":1,"feats/details":1,"feats/home":1,"forums/details":1,"forums/home":1,"forums/search":1,"forums/topic":1,"help":1,"oddnet":1,"privacy":1,"profile":1,"profile/achievements":1,"profile/feats":1,"profile/notifications":1,"profile/settings":1,"profile/skills":1,"profile/upgrades":1,"terms":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"downloads":"downloads","encyclopedia":"encyclopedia","encyclopedia/achievements":"encyclopedia/achievements","encyclopedia/achievements/category":"encyclopedia/achievements/category","encyclopedia/achievements/details":"encyclopedia/achievements/details","encyclopedia/giants":"encyclopedia/giants","encyclopedia/giants/details":"encyclopedia/giants/details","encyclopedia/home":"encyclopedia/home","encyclopedia/inhabitants":"encyclopedia/inhabitants","encyclopedia/inhabitants/category":"encyclopedia/inhabitants/category","encyclopedia/inhabitants/details":"encyclopedia/inhabitants/details","encyclopedia/items":"encyclopedia/items","encyclopedia/items/category":"encyclopedia/items/category","encyclopedia/items/details":"encyclopedia/items/details","encyclopedia/locations":"encyclopedia/locations","encyclopedia/locations/details":"encyclopedia/locations/details","encyclopedia/locations/region":"encyclopedia/locations/region","encyclopedia/search":"encyclopedia/search","encyclopedia/skills":"encyclopedia/skills","encyclopedia/skills/category":"encyclopedia/skills/category","encyclopedia/skills/details":"encyclopedia/skills/details","encyclopedia/upgrades":"encyclopedia/upgrades","encyclopedia/upgrades/category":"encyclopedia/upgrades/category","encyclopedia/upgrades/details":"encyclopedia/upgrades/details","feats":"feats","feats/details":"feats/details","feats/home":"feats/home","forums":"forums","forums/details":"forums/details","forums/home":"forums/home","forums/search":"forums/search","forums/topic":"forums/topic","help":"help","oddnet":"oddnet","password":"password","privacy":"privacy","profile":"profile","profile/achievements":"profile/achievements","profile/feats":"profile/feats","profile/home":"profile/home","profile/notifications":"profile/notifications","profile/post":"profile/post","profile/settings":"profile/settings","profile/skills":"profile/skills","profile/upgrades":"profile/upgrades","search":"search","subscriptions":"subscriptions","terms":"terms"}[chunkId]||chunkId) + "." + {"downloads":"31d6cfe0","encyclopedia":"31d6cfe0","encyclopedia/achievements":"31d6cfe0","encyclopedia/achievements/category":"31d6cfe0","encyclopedia/achievements/details":"e6825336","encyclopedia/giants":"31d6cfe0","encyclopedia/giants/details":"31d6cfe0","encyclopedia/home":"31d6cfe0","encyclopedia/inhabitants":"31d6cfe0","encyclopedia/inhabitants/category":"31d6cfe0","encyclopedia/inhabitants/details":"13804337","encyclopedia/items":"31d6cfe0","encyclopedia/items/category":"31d6cfe0","encyclopedia/items/details":"e6825336","encyclopedia/locations":"31d6cfe0","encyclopedia/locations/details":"31d6cfe0","encyclopedia/locations/region":"31d6cfe0","encyclopedia/search":"31d6cfe0","encyclopedia/skills":"31d6cfe0","encyclopedia/skills/category":"31d6cfe0","encyclopedia/skills/details":"e6825336","encyclopedia/upgrades":"31d6cfe0","encyclopedia/upgrades/category":"31d6cfe0","encyclopedia/upgrades/details":"31d6cfe0","feats":"31d6cfe0","feats/details":"6a1a7977","feats/home":"35cd701c","forums":"31d6cfe0","forums/details":"645eecca","forums/home":"83f57d39","forums/search":"645eecca","forums/topic":"089be4e3","help":"dd810e1f","oddnet":"20e64e6d","password":"31d6cfe0","privacy":"10b89946","profile":"709efae8","profile/achievements":"83f57d39","profile/feats":"259f89ba","profile/home":"31d6cfe0","profile/notifications":"efe74df6","profile/post":"31d6cfe0","profile/settings":"c7f899e0","profile/skills":"83f57d39","profile/upgrades":"83f57d39","search":"31d6cfe0","subscriptions":"31d6cfe0","terms":"bb726aef"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
